import React from 'react';
import { Dialog, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import _ from 'lodash';
import { DependencyDisplay } from './DependencyDisplay';

const InfoDialog = ({ open, handleClose, dependencyStructure, entityId, type, refetchData, refetchCount }) => {
  const hasDependencies = !_.isEmpty(dependencyStructure);

  return (
    <Dialog
      open={open}
      keepMounted
      onClose={handleClose}
      aria-labelledby="info-dialog-title"
      aria-describedby={hasDependencies ? undefined : 'info-dialog-description'}>
      <DialogTitle id="info-dialog-title">References for this {type}</DialogTitle>
      <DialogContent>
        {hasDependencies ? (
          <DependencyDisplay
            dependencyStructure={dependencyStructure}
            type={type}
            entityId={entityId}
            onClose={handleClose}
            refetchData={refetchData}
            refetchCount={refetchCount}
          />
        ) : (
          <DialogContentText id="info-dialog-description">This {type} has no references.</DialogContentText>
        )}
      </DialogContent>
    </Dialog>
  );
};

export { InfoDialog };
